// CustomTabs.js
import React from "react";
import { Box, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { colors } from "../../../../utils";

const CustomTabs = ({
  selectedTab,
  handleTabChange,
  options,
  style,
}) => {
  const tabStyle = (value) => ({
    color: selectedTab === value ? colors.PrimaryPurple : colors.lightGrey,
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: "400",
    borderRadius: "4px",
    textTransform: "capitalize",
    borderTop: `2px solid`,
    borderColor: selectedTab === value ? `${colors.PrimaryPurple600}` : colors.background,
    backgroundColor:
      selectedTab === value ? colors.PrimaryPurple100 : colors.background,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "0px",
    minWidth: 0,
  });

  return (
    <TabContext value={selectedTab}>
      <Box>
        <TabList
          sx={{
            display: "flex",
            justifyContent: "space-between",
            height: "48px",
            marginBottom: "20px",
            "& .MuiTabs-indicator": {
              display: "none !important",
            },
          }}
          onChange={handleTabChange}
          variant="fullWidth"
        >
          {Array.from(options.keys()).map((key, index) => (
            <Tab
              key={key}
              label={options.get(key).label}
              value={key}
              sx={{ marginLeft: index !== 0 ? "10px" : 0}}
              style={{ ...tabStyle(key), ...style }}
              disabled={options.get(key).disabled}
            />
          ))}
        </TabList>
      </Box>
      {Array.from(options.keys()).map((key) => (
        <TabPanel style={{ padding: 0 }} key={key} value={key}>
          {options.get(key)?.component}
        </TabPanel>
      ))}
    </TabContext>
  );
};

export default CustomTabs;
